class CartNotification extends HTMLElement {
	constructor() {
		super();
		const appHeight = () => {
			const doc = document.documentElement;
			const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
			doc.style.setProperty('--viewport-height', `${vh}px`);
		};
		window.addEventListener('resize', appHeight);
		if (window.visualViewport) {
			window.visualViewport.addEventListener('resize', appHeight);
			window.visualViewport.addEventListener('scroll', appHeight);
		}
		appHeight();

		this.notification = document.getElementById('cart-notification');
		this.header = document.querySelector('sticky-header');
		this.onBodyClick = this.handleBodyClick.bind(this);
		if (!this.notification) return;

		this.notification.addEventListener(
			'keyup',
			(evt) => evt.code === 'Escape' && this.close()
		);
		this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
			closeButton.addEventListener('click', this.close.bind(this));
		});

		// Handle remove-item clicks in drawer (cart-remove-button may not work in injected content)
		this.addEventListener('click', this.handleDrawerRemoveClick.bind(this));
		// Handle quantity +/- in drawer (capture phase so we run before quantity-input)
		this.addEventListener('click', this.handleDrawerQuantityClick.bind(this), true);
		// Handle close button in drawer (scrolls with content, added dynamically)
		this.addEventListener('click', this.handleDrawerCloseClick.bind(this));
		// Handle Continue Shopping button (empty state) - close drawer
		this.addEventListener('click', this.handleContinueCloseClick.bind(this));
		// Handle discount code apply and remove
		this.addEventListener('click', this.handleDiscountApplyClick.bind(this));
		this.addEventListener('click', this.handleDiscountRemoveClick.bind(this));
		// Enter key to submit discount
		this.addEventListener('keydown', this.handleDiscountKeydown.bind(this));
		// Mobile: prevent extra scroll when discount input focused (drawer should only move with keyboard)
		this.addEventListener('focusin', this.handleDiscountFocusIn.bind(this));
		this.addEventListener('focusout', this.handleDiscountFocusOut.bind(this));
	}

	handleDrawerQuantityClick(evt) {
		const btn = evt.target.closest('#cart-notification-product .quantity__button.plus, #cart-notification-product .quantity__button.minus');
		if (!btn) return;
		evt.preventDefault();
		evt.stopPropagation();
		const line = parseInt(btn.getAttribute('data-line'), 10);
		const input = btn.closest('quantity-input')?.querySelector('.quantity__input');
		if (!input || isNaN(line)) return;
		let qty = parseInt(input.value, 10) || 0;
		if (btn.classList.contains('plus')) qty = Math.min(qty + 1, 999);
		else if (btn.classList.contains('minus')) qty = Math.max(qty - 1, 0);
		const changeUrl = (window.Shopify?.routes?.root || '/') + 'cart/change.js';
		fetch(changeUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ line, quantity: qty }),
		})
			.then((res) => res.json())
			.then(() => this.refreshDrawerContents())
			.catch((err) => console.error('Quantity update failed:', err));
	}

	handleDrawerCloseClick(evt) {
		if (evt.target.closest('.cart-drawer__close')) {
			evt.preventDefault();
			this.close();
		}
	}
	handleContinueCloseClick(evt) {
		if (evt.target.closest('.cart-notification__continue-link, .cart-notification__continue-close')) {
			evt.preventDefault();
			this.close();
		}
	}
	applyDiscountCode() {
		const input = document.getElementById('cart-drawer-discount-input');
		const errorEl = document.getElementById('cart-drawer-discount-error');
		if (!input) return;
		const code = (input.value || '').trim();
		if (!code) return;
		if (errorEl) {
			errorEl.textContent = '';
			errorEl.style.display = 'none';
		}
		const updateUrl = (window.Shopify?.routes?.root || '/') + 'cart/update.js';
		fetch(updateUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ discount: code }),
		})
			.then((res) => res.json().then((data) => ({ ok: res.ok, data })).catch(() => ({ ok: false, data: null })))
			.then(({ ok, data }) => {
				const apiError = data && (data.message || data.description || data.errors);
				const apps = data && (data.cart_level_discount_applications || data.discount_applications || []);
				const hasDiscounts = Array.isArray(apps) && apps.length > 0;
				if (!ok || apiError) {
					const msg = this.getDiscountErrorMessage(data);
					if (errorEl) {
						errorEl.textContent = msg;
						errorEl.style.display = 'block';
					}
				} else if (hasDiscounts) {
					this.refreshDrawerContents();
					} else {
					if (errorEl) {
						errorEl.textContent = 'Discount Code not valid';
						errorEl.style.display = 'block';
					}
				}
			})
			.catch((err) => {
				console.error('Discount apply failed:', err);
				if (errorEl) {
					errorEl.textContent = 'Discount Code not valid';
					errorEl.style.display = 'block';
				}
			});
	}
		getDiscountErrorMessage(data) {
		if (!data) return 'Discount Code not valid';
		if (typeof data.message === 'string' && data.message) return data.message;
		if (typeof data.description === 'string' && data.description) return data.description;
		if (typeof data.errors === 'string' && data.errors) return data.errors;
		if (Array.isArray(data.errors) && data.errors.length) return data.errors[0];
		return 'Discount Code not valid';
	}
	handleDiscountApplyClick(evt) {
		const btn = evt.target.closest('#cart-notification-product .cart-drawer__discount-apply');
		if (!btn) return;
		evt.preventDefault();
		this.applyDiscountCode();
	}
	handleDiscountKeydown(evt) {
		if (evt.code !== 'Enter') return;
		const input = evt.target.closest('#cart-notification-product .cart-drawer__discount-input');
		if (!input) return;
		evt.preventDefault();
		this.applyDiscountCode();
	}
	handleDiscountFocusIn(evt) {
		if (!evt.target.matches('#cart-notification-product .cart-drawer__discount-input')) return;
		if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
		this._discountScrollLockY = window.scrollY;
		this._scrollLockHandler = () => {
			window.scrollTo(0, this._discountScrollLockY);
		};
		window.addEventListener('scroll', this._scrollLockHandler, { passive: false });
	}
	handleDiscountFocusOut(evt) {
		if (!evt.target.matches('#cart-notification-product .cart-drawer__discount-input')) return;
		if (this._scrollLockHandler) {
			window.removeEventListener('scroll', this._scrollLockHandler);
			this._scrollLockHandler = null;
		}
	}
	handleDiscountRemoveClick(evt) {
		const btn = evt.target.closest('#cart-notification-product .cart-drawer__discount-remove');
		if (!btn) return;
		evt.preventDefault();
		const updateUrl = (window.Shopify?.routes?.root || '/') + 'cart/update.js';
		fetch(updateUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ discount: '' }),
		})
			.then((res) => res.json())
			.then(() => this.refreshDrawerContents())
			.catch((err) => console.error('Discount remove failed:', err));
	}

	handleDrawerRemoveClick(evt) {
		const removeLink = evt.target.closest('#cart-notification-product a.remove-item');
		if (!removeLink || !removeLink.href) return;
		evt.preventDefault();

		const removeUrl = removeLink.href;
		const urlObj = new URL(removeUrl, window.location.origin);
		const line = urlObj.searchParams.get('line');
		const id = urlObj.searchParams.get('id');

		const changeUrl = (window.Shopify?.routes?.root || '/') + 'cart/change.js';
		const body = line ? { line: parseInt(line, 10), quantity: 0 } : id ? { id: id, quantity: 0 } : null;

		if (!body) {
			window.location.href = removeUrl;
			return;
		}

		fetch(changeUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
		})
			.then((res) => res.json())
			.then(() => this.refreshDrawerContents())
			.catch(() => { window.location.href = removeUrl; });
	}

	refreshDrawerContents() {
		const sectionsParam = 'cart-icon-bubble,cart-notification-product';
		const url = (window.Shopify?.routes?.root || '/') + 'cart?sections=' + sectionsParam;

		fetch(url)
			.then((res) => res.json())
			.then((data) => {
				const sections = data?.sections || data;
				if (!sections) return;

				// Update cart icon (if section exists in theme)
				const bubbleHtml = sections['cart-icon-bubble'];
				if (bubbleHtml) {
					const bubbleEl = document.getElementById('cart-icon-bubble');
					if (bubbleEl) {
						const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
						const content = parsed.querySelector('.shopify-section');
						if (content) bubbleEl.innerHTML = content.innerHTML;
					}
				}
				// Update drawer content (preserve scroll position)
				const productHtml = sections['cart-notification-product'];
				if (productHtml) {
					const productEl = document.getElementById('cart-notification-product');
					if (productEl) {
						const scrollEl = productEl.querySelector('.cart-drawer__items');
						const scrollTop = scrollEl ? scrollEl.scrollTop : 0;
						const parsed = new DOMParser().parseFromString(productHtml, 'text/html');
						const content = parsed.querySelector('.shopify-section');
						if (content) productEl.innerHTML = content.innerHTML;
						const newScrollEl = productEl.querySelector('.cart-drawer__items');
						if (newScrollEl) newScrollEl.scrollTop = scrollTop;
						// Show/hide footer links based on empty state
						const linksFooter = document.getElementById('cart-notification-links-footer');
						if (linksFooter) {
							linksFooter.style.display = productEl.querySelector('.cart-notification__links--empty') ? 'none' : '';
						}
					}
				}
			})
			.catch((err) => console.error('Cart refresh failed:', err));
	}

	open() {
		if (!this.notification) return;
		var self = this;
		// Update viewport height for iOS Safari (URL bar expanded)
		const appHeight = () => {
			const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
			document.documentElement.style.setProperty('--viewport-height', `${vh}px`);
		};
		appHeight();
		this.notification.classList.add('animate', 'active');
		document.body.classList.add('show-mini');
		// Show/hide footer links based on empty state
		const productEl = document.getElementById('cart-notification-product');
		const linksFooter = document.getElementById('cart-notification-links-footer');
		if (linksFooter && productEl) {
			linksFooter.style.display = productEl.querySelector('.cart-notification__links--empty') ? 'none' : '';
		}
		$(".cart-notification-wrapper .cart-notification-product").scrollTop(0);
		this.notification.addEventListener(
			'transitionend',
			() => {
				this.notification.focus();
				trapFocus(this.notification);
			},
			{ once: true }
		);
		// align height
		function alignHeight(selector) {
			jQuery(selector).css('height', '');
			var minHeight = 0;
			jQuery(selector).each(function () {
				if (minHeight < jQuery(this).outerHeight()) {
					minHeight = jQuery(this).outerHeight();
				}
			});
			if (minHeight > 0) {
				jQuery(selector).css('height', minHeight);
			}
		}
		function alignHeightRow(selector, n) {
			var items = jQuery(selector);
			var newArrays = new Array(Math.ceil(items.length / n))
				.fill()
				.map((_) => items.splice(0, n));

			$(newArrays).each(function () {
				jQuery(this).css('height', '');
				var minHeight = 0;
				jQuery(this).each(function () {
					if (minHeight < jQuery(this).outerHeight()) {
						minHeight = jQuery(this).outerHeight();
					}
				});
				if (minHeight > 0) {
					jQuery(this).css('height', minHeight);
				}
			});
		}
		setTimeout(function () {
			alignHeightRow('.sub-collections a p', 2);
			alignHeightRow('.product-grid .card-wrapper .card__heading', 2);
			alignHeightRow('.card-wrapper .price__container', 2);
			alignHeightRow('.shipping-time-and-cart', 2);
		}, 500);
		this._resizeHandler = function () {
			setTimeout(function () {
				alignHeightRow('.sub-collections a p', 2);
				alignHeightRow('.product-grid .card-wrapper .card__heading', 2);
				alignHeightRow('.card-wrapper .price__container', 2);
				alignHeightRow('.shipping-time-and-cart', 2);
			}, 500);
		};
		jQuery(window).on('resize', this._resizeHandler);

		document.body.addEventListener('click', this.onBodyClick);
		this._headerCloseHandler = function () { self.close(); };
		$(document).find('.cart-notification__header-desktop').on('click', this._headerCloseHandler);
		this._documentClickHandler = function (e) {
			var container = $('.cart-notification');
			if (!$(e.target).closest(container).length) {
				self.close();
			}
		};
		$(document).on('click', this._documentClickHandler);
	}

	close() {
		if (!this.notification) return;
		this.notification.classList.remove('active');
		document.body.classList.remove('show-mini');
		document.body.removeEventListener('click', this.onBodyClick);
		if (typeof removeTrapFocus === 'function') {
			removeTrapFocus(this.activeElement);
		}
		if (this._resizeHandler) {
			jQuery(window).off('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (this._headerCloseHandler) {
			$(document).find('.cart-notification__header-desktop').off('click', this._headerCloseHandler);
			this._headerCloseHandler = null;
		}
		if (this._documentClickHandler) {
			$(document).off('click', this._documentClickHandler);
			this._documentClickHandler = null;
		}
	}

	renderContents(parsedState) {
		this.cartItemKey = parsedState.key;
		this.getSectionsToRender().forEach((section) => {
			const el = document.getElementById(section.id);
			if (!el) return;
			const html = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector || '.shopify-section'
			);
			if (html != null) el.innerHTML = html;
		});

		if (this.header) this.header.reveal();
		this.open();
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-notification-product',
				selector: '.shopify-section',
			},
			{
				id: 'cart-icon-bubble',
			},
		];
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		if (!html) return null;
		const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
		return node ? node.innerHTML : null;
	}

	handleBodyClick(evt) {
		const target = evt.target;
		if (target !== this.notification && !target.closest('cart-notification')) {
			const disclosure = target.closest('details-disclosure');
			this.activeElement = disclosure
				? disclosure.querySelector('summary')
				: null;
			this.close();
		}
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-notification', CartNotification);
